import { SaveGroupError } from "./SaveGroupError";

import type { LoginError } from "./LoginError";
import type { AuthError } from "./AuthError";
import type { TimeoutError } from "./TimeoutError";
import type { SaveSubCategoryError } from "./SaveSubCategoryError";
import type { SaveContentError } from "./SaveContentError";
import type { SaveUserError } from "./SaveUserError";
import type { ChangePasswordError } from "./ChangePasswordError";
import type { NotFoundError } from "./NotFoundError";
import type { InternalServerError } from "./InternalServerError";
import type { DeleteContentError } from "./DeleteContentError";
import { DeleteAllReverseRelationsError } from "./DeleteAllReverseRelationsError";
import { DeleteReverseRelationError } from "./DeleteReverseRelationError";
import { InsertInquiryError } from "./InsertInquiryError";
import { WebLoginError } from "./WebLoginError";
import { WebRegistrationError } from "./WebRegistrationError";
import { WebUserConfirmationError } from "./WebUserConfirmationError";
import { WebUserConfirmationResendError } from "./WebUserConfirmationResendError";
import { WebLostPasswordError } from "./WebLostPasswordError";
import { WebUserCancelationError } from "./WebUserCancelationError";
import { WebUserUpdateError } from "./WebUserUpdateError";
import { WebResetPasswordError } from "./WebResetPasswordError";

export type AnyError =
  | NotFoundError
  | InternalServerError
  | AuthError
  | TimeoutError
  | LoginError
  | WebLoginError
  | SaveContentError
  | DeleteContentError
  | DeleteAllReverseRelationsError
  | DeleteReverseRelationError
  | SaveSubCategoryError
  | SaveUserError
  | SaveGroupError
  | ChangePasswordError
  | InsertInquiryError
  | WebLoginError
  | WebRegistrationError
  | WebResetPasswordError
  | WebUserUpdateError
  | WebUserConfirmationError
  | WebUserConfirmationResendError
  | WebLostPasswordError
  | WebUserCancelationError;

export class XcoreError extends Error {
  public name: AnyError["name"] = undefined!;

  public url: string;

  public constructor(url: string, msg: string) {
    super(msg);
    this.url = url;
  }
}
